var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoxFilled = function SvgBoxFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 18.333c0 .059.008.117.025.167l-6.542-3.775a1.032 1.032 0 0 1-.516-.9V6.258a.5.5 0 0 0 .158.134l6.875 3.966v7.975Zm7.7-13.1-6.55-3.775a1.015 1.015 0 0 0-1.042 0L2.925 5.233a.977.977 0 0 1 .2.075L10 9.275l6.875-3.967a.976.976 0 0 1 .2-.075Zm.425 1.159-6.875 3.966v7.975a.484.484 0 0 1-.025.159l6.542-3.767a1.05 1.05 0 0 0 .516-.9V6.258a.499.499 0 0 1-.158.134Z",
    fill: "current"
  })));
};
export default SvgBoxFilled;